"use client";

import { motion } from "motion/react";
import { Moon, Sun } from "lucide-react";
import { Button } from "../ui";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../app/components/ui/tooltip";
import { useTheme } from "../../context/ThemeProvider";

const label = "Switch theme";

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          <Button
            variant="ghost"
            size="icon"
            type="button"
            aria-label={label}
            onClick={toggleTheme}
            className="relative overflow-hidden"
          >
            <motion.span
              key={theme}
              initial={{ opacity: 0, rotate: -45 }}
              animate={{ opacity: 1, rotate: 0 }}
              transition={{ duration: 0.2 }}
              className="inline-flex"
            >
              {theme === "dark" ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
            </motion.span>
          </Button>
        </motion.div>
      </TooltipTrigger>
      <TooltipContent side="bottom">{label}</TooltipContent>
    </Tooltip>
  );
}
